// lbl.register.

export const register = {
    prefix_list: [
        {
            text: 'Mr.',
            value: 'mr',
        },
        {
            text: 'Ms.',
            value: 'ms',
        },
        {
            text: 'Mrs.',
            value: 'mrs',
        },
    ],
    prefix: {
        name: '',
        placeholder: '',
        required: 'Please select your gender',
        too_short: '',
        invalid: '',
    },
    firstname: {
        name: 'Firstname',
        placeholder: 'Firstname',
        required: 'Please enter first name',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: 'Lastname',
        required: 'Please enter last name',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'Mobile no.',
        placeholder: 'Mobile no.',
        required: 'Please enter mobile no.',
        too_short: 'Contact number must be 10 digits',
        invalid: 'Incorrect contact number format',
    },
    email: {
        name: 'Email',
        placeholder: 'Email',
        required: 'Please enter email',
        too_short: '',
        invalid: 'Incorrect email format',
    },
    birthdate: {
        name: 'Birth Date',
        placeholder: 'Birth Date',
        required: '',
        too_short: '',
        invalid: '',
    },
    term_market_1:'I am interested in and would like to receive information about products, services, free, gifts, discounts, promotions and other relevant activities from Burger King and ',
    term_market_2:'affiliated companies and relevant brands',
    term_cancel: 'You can withdraw consent at any time by sending email to us at',
    warnning_next: 'You have read and acceopted the',
    warnning_next_2: 'and',
    warnning_next_3: 'of Burger (Thailand) Limited.',
    term: 'Terms&Conditions',
    privacy: 'Privacy policy',
    register: 'Register',
    otp_popup: {
        title: 'Enter the OTP received on the registered mobile number',
        refcode: 'Ref. Code',
        estimated: 'Estimated time : ',
        min: 's',
        did_not_otp: 'Did not receive OTP? ',
        resend: 'Resend',
        confirm: 'Confirm',
        invalid_otp: 'Invalid OTP'
    },

    setup_pin: 'Please setup PIN',
    enter_pin: 'Enter your PIN',
    confirm_pin: 'Confirm PIN',
    pin_not_match: 'Pin code do not match. Please try again',
    

    register_completed: 'Your registration is completed',
    Now_you: 'Now you are',
    burgerking: 'BURGER KING®',
    enjoy_your_meal: 'member. Enjoy your meal!',
    start_your_order: 'Start your order',

    reset_password: {
        title: 'Reset PIN',
        msg: "Enter the mobile number associated with your account and we'll send message with instructions to reset your mobile PIN",
        send: 'Send',
        birthdate_not_match: 'Sorry, you birthdate does not match. Please try again.',
        success: 'Reset password link has been sent. Please check',
    },

    change_pin_title: {
        enter_pin: 'Please enter Pin',
        confirm_pin: 'Confirm Pin',
    },

    forgot_popup: {
        msg_1: 'Do you want send message with instructions to reset your PIN to mobile no. or email',
        msg_2: "what'd you like to do",
        mobile: 'Mobile no.',
        email: 'Email'
    },

    error_email_duplicate: 'This email has already been registered.',
    error_mobile_duplicate: 'This mobile no. has already been registered. Please try to login with your registered.',

    traces_title: 'Free Crowns!',
    traces_msg: "Congratulations! You've received {0} welcome crowns!",
    traces_btn: 'Go to my rewards!',

    badges_title: 'Free Reward!',
    badges_name: 'Congratutions! You have received a FREE e-voucher {0}',
    badges_btn: 'Go to my rewards!'
};
